<template>
  <div id="Answer">
    <div class="profile">
      <Profile :user="answer.user"
               :created="answer.time"/>
    </div>
    <pre class="content" v-line-clamp="mode=='detail'?100:4" v-html="answer.content"></pre>
    <div class="options" v-if="mode=='detail'">
      <div class="left">
        <LikeCount :key="'LikeCount'+answer.uuid"
                   :answer="answer"
                   v-if="answer"/>
      </div>
      <div class="right">
        <Edit v-if="answer && user.uuid == answer.user.uuid"
              :answer="answer"
              @editAnswer="editAnswer"
              @removeAnswer="removeAnswer"/>
      </div>
    </div>
  </div>
</template>

<script>
// Services
import AuthService from '@/service/auth/AuthService'

// Components Section
import Profile from './Profile'
import LikeCount from './LikeCount'
import Edit from './Edit'

// Variable Section
// let self

export default {
  name: 'Answer',
  props: ['mode', 'answer', 'isLast'],
  components: {
    Profile,
    LikeCount,
    Edit
  },
  data: function () {
    return {
      user: null,
      content: ''
    }
  },
  computed: {},
  created() {
    this.user = AuthService.getProfile()
  },
  destroyed() {},
  methods: {
    editAnswer(answer) {
      this.$emit('editAnswer', answer)
    },
    removeAnswer(answer) {
      this.$emit('removeAnswer', answer)
    }
  },
}
</script>

<style lang="scss" scoped>
  #Answer {
    width: 100%;

    .profile {
      width: 100%;
    }

    .content {
      width: 100%;
      margin-top: 17px;
      font-size: 15px;
      line-height: 1.47;
      letter-spacing: -0.3px;
      color: #424242;
      white-space: pre-line;
    }
    .options {
      width: 100%;
      margin-top: 20px;
      .left {
        float: left;
      }

      .right {
        float: right;
      }
    }
  }
</style>
